<button (click)="onClick.emit(); setFocus.emit()"
        class="profile-add-another-button px-3"
        data-automation-id="profile-add-another-button"
        [attr.aria-label]="inputLabel ? (('profileAddAnother' | translate) + ' ' + inputLabel) : undefined">
  <fa-icon [icon]="plusIcon" class="mr-1"></fa-icon>
  <ng-content></ng-content>
</button>
